import { useEffect, useState } from 'react';
import classNames from 'classnames';

export interface ButtonGroupDefinition<T> {
  text: string;
  value: T;
  disabled?: boolean;
}

interface ButtonGroupProps<T> {
  buttonGroupDefinition: ButtonGroupDefinition<T>[];
  onButtonClick: (value: T) => unknown;
  styles?: string[];
  testId?: string;
  selectedButton?: number;
}

export const ButtonGroup = <T,>({
  buttonGroupDefinition,
  onButtonClick,
  styles = [],
  testId,
  selectedButton,
}: ButtonGroupProps<T>) => {
  const [activeButton, setActiveButton] = useState(0);

  useEffect(() => {
    setActiveButton(selectedButton);
  }, [selectedButton]);

  const buttonGroup = buttonGroupDefinition.map((button, index) => {
    const isFirst = index === 0;
    const isLast = index === buttonGroupDefinition.length - 1;

    return (
      <button
        key={button.text}
        type="button"
        disabled={button.disabled}
        className={classNames(
          'text-sm',
          'px-4',
          'py-5',
          'cursor-pointer',
          'border-r',
          'border-y',
          index === activeButton ? 'bg-[#D7D7D7]' : 'border-[#EBEBEB]',
          isFirst && 'border-l rounded-l-sm',
          isLast && 'rounded-r-sm',
          button.disabled ? 'bg-gray-100 cursor-not-allowed opacity-50' : '',
          ...styles
        )}
        onClick={() => {
          onButtonClick(button.value);
          setActiveButton(index);
        }}
      >
        {button.text}
      </button>
    );
  });

  return (
    <div className="inline-flex" data-testid={testId}>
      {buttonGroup}
    </div>
  );
};
